import { NavigationWrapper } from 'Helpers/NavigateHelper'
import { NegateFilterSearched, subruleDropdownModified } from '../../Constants/Configuration'
import {
  createNewVirtualRule,
  generateVirtualSeason,
  calculateMostRecentSeasonRuleStartEndDate,
  retrieveRuleFromSubrule,
} from '../../Helpers/DiscountHelper'
import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'
import {
  updateRule,
  removeRule,
  setSeasonRuleList,
  addRule,
  removeSeason,
  updateSubRule,
  setSeasonList,
  removeSubRule,
  addSeason,
} from '../../Slices/Omnichannel/SeasonRuleSlice'
import {
  saveSorting,
  setActiveSubRuleAutocomplete,
  setEditSelection,
  setLoading,
  setSubRuleArticles,
} from '../../Slices/Omnichannel/SubRuleSlice'
import { updateDiscount } from './DiscountService'
import { prepareStores } from 'Helpers/StoreHelper'

const getSeasonRules = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const typeOfChannel = state.present.discount.typeOfChannel
  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  return createRequest(
    `/api/mprules/all/?config=${state.present.article.serverConfig}&typeOfChannel=${typeOfChannel}`,
    'GET',
    undefined,
    token,
  )
    .then(response => response.json())
    .then(data => {
      if (data && data.length !== 0) {
        dispatch(setSeasonRuleList(data))
      }
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed retrieve season rules getSeasonRules')
    })
}

const saveSeasonRule = (seasonRule, discountToSave, navigationWrapper: NavigationWrapper) => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  const language = state.present.language.value
  const isFromVirtualRule = seasonRule.virtualId

  return createRequest(
    '/api/mprules/?config=' + state.present.article.serverConfig,
    'POST',
    seasonRule,
    token,
    true,
    true,
  )
    .then(response => response.json())
   .then(x => {
  seasonRule.id = x
  dispatch(updateRule(seasonRule))

  if (discountToSave.length > 0) {
    dispatch(updateDiscount(x, false, undefined, isFromVirtualRule))
  }
  if (isFromVirtualRule) {
    navigationWrapper?.navigateToRule(seasonRule.id)
  }

  return x
})
    .catch(err => {
      handleErrorCatchLog(err, renderTranslation(language, TranslationKeys.warningFailedSaveSeasonRule))
    })
}

const saveSeasonRuleCopy = (seasonRule, ruleToCopyId, navigationWrapper: NavigationWrapper) => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  return createRequest(
    '/api/mprules/' + ruleToCopyId + '/copy/?config=' + state.present.article.serverConfig,
    'POST',
    seasonRule,
    token,
    true,
    true,
  )
    .then(response => response.json())
    .then(newId => {
      seasonRule.id = newId
      dispatch(addRule(seasonRule))
      dispatch(getSeasonRules())
      navigationWrapper?.navigateToRule(seasonRule.id)
      return newId
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed copy season rule saveSeasonRuleCopy')
    })
}

const deleteAllSeasonRules =
  (seasonObj: any, isSelectedRuleInSeason: boolean, navigationWrapper: NavigationWrapper) => (dispatch, getState) => {
    const state = getState()
    const token = getTokenFromSessionStorage()
    const typeOfChannel = state.present.discount.typeOfChannel
    if (!state.present.article.serverConfig || seasonObj.rules.length === 0 || !token) {
      if (seasonObj.rules.length === 0) {
        dispatch(removeSeason(seasonObj.season))
      }
      return new Promise(resolve => {
        resolve({})
      })
    }

    return createRequest(
      `/api/mprules/all/?config=${state.present.article.serverConfig}&typeOfChannel=${typeOfChannel}`,
      'DELETE',
      seasonObj.season,
      token,
      true,
      true,
    )
      .then(() => {
        if (isSelectedRuleInSeason) {
          navigationWrapper?.navigateToOmnichannel()
        }
        dispatch(getSeasonRules())
      })
      .catch(err => {
        handleErrorCatchLog(err, 'failed delete all season rule deleteAllSeasonRules')
      })
  }

const deleteRule = (rule, isSubRuleDelete, navigationWrapper?: NavigationWrapper) => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  if (rule.virtualId) {
    if (isSubRuleDelete) {
      dispatch(removeSubRule(rule))
    } else {
      dispatch(removeRule(rule))
    }

    navigationWrapper?.navigateToOmnichannel()

    return new Promise(resolve => {
      resolve({})
    })
  }

  const url = `/api/mprules/${rule.id}?config=${state.present.article.serverConfig}`
  return createRequest(url, 'DELETE', rule, token, true, true)
    .then(x => {
      if (isSubRuleDelete) {
        dispatch(removeSubRule(rule))
      } else {
        dispatch(removeRule(rule))
      }

      navigationWrapper?.navigateToOmnichannel()
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed delete season rule deleteRule')
    })
}

const getSeasons = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const typeOfChannel = state.present.discount.typeOfChannel

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  return createRequest(
    `/api/mprules/seasons/?config=${state.present.article.serverConfig}&typeOfChannel=${typeOfChannel}`,
    'GET',
    undefined,
    token,
  )
    .then(response => response.json())
    .then(data => {
      if (data && data.length !== 0) {
        dispatch(setSeasonList(data))
      }
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed retrieve seasons getSeasons')
    })
}

const restoreSeasonRules = seasonId => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const typeOfChannel = state.present.discount.typeOfChannel

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  const season = state.present.seasonRule.seasonList.find(x => x.id === seasonId)

  return createRequest(
    `/api/mprules/restore/?config=${state.present.article.serverConfig}&typeOfChannel=${typeOfChannel}`,
    'POST',
    season,
    token,
  )
    .then(response => {
      if (response) {
        dispatch(getSeasonRules())
      }
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed restore season rules for current season selected')
    })
}

const copyEntireSeason = (newSeason, oldSeasonRules) => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  var requests = []

  const [ruleDateCopy, ruleEndDateCopy] = calculateMostRecentSeasonRuleStartEndDate(oldSeasonRules.rules)

  oldSeasonRules.rules.forEach(rule => {
    const ruleToSend = { ...rule }
    ruleToSend.season = newSeason
    ruleToSend.id = 0
    ruleToSend.startDate = ruleDateCopy
    ruleToSend.endDate = ruleEndDateCopy
    requests.push(
      createRequest(
        '/api/mprules/' + rule.id + '/copy/?config=' + state.present.article.serverConfig,
        'POST',
        ruleToSend,
        token,
        true,
        true,
      ),
    )
  })

  return Promise.all(requests)
    .then(res => {
      dispatch(getSeasonRules())
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed copy entire season copyEntireSeason')
    })
}

const addNewSeasonToSeasonList =
  (seasonSelected, availableSeasons, navigationWrapper: NavigationWrapper) => (dispatch, getState) => {
    if (availableSeasons) {
      const state = getState()
      const language = state.present.language.value
      const seasonRuleList = state.present.seasonRule.seasonRuleList
      const seasonToAdd = availableSeasons.find(x => x.id === seasonSelected)
      dispatch(addSeason(generateVirtualSeason(seasonToAdd)))
      dispatch(createNewVirtualRule([], seasonRuleList, language, seasonToAdd, navigationWrapper))
    } else {
      dispatch(restoreSeasonRules(seasonSelected))
    }
  }

const searchSubRulesArticles = async (state): Promise<{ results: any[]; rowCount: number }> => {
  const isAnyTableFilterSet = Object.keys(state.present.subRule.tableFilters).length !== 0
  const isFilterAvailabilitySet = state.present.subRule.filterResultByAvailability
  const filterDiscountVisibilityDropdownValue =
    state.present.subRule.filterDiscountVisibilityDropdownValue === subruleDropdownModified
  const listingsDiscountToSave = state.present.subRule.listingsDiscountToSave
  const discountArticleIdList = listingsDiscountToSave.map(x => x.article)

  const subRuleId: number = state.present.subRule.subRuleId
  const rule: any = retrieveRuleFromSubrule(subRuleId, state.present.seasonRule.seasonRuleList)
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    (filterDiscountVisibilityDropdownValue &&
      listingsDiscountToSave.length === 0 &&
      state.present.subRule.subRuleId < 0) ||
    (!isFilterAvailabilitySet && !isAnyTableFilterSet && !filterDiscountVisibilityDropdownValue) ||
    !subRuleId ||
    Object.keys(rule).length === 0 ||
    !token
  ) {
    return {
      results: [],
      rowCount: 0,
    }
  }

  const tableFiltersToPass = { ...state.present.subRule.tableFilters }
  if (tableFiltersToPass['season']) {
    delete tableFiltersToPass['season']
  }

  const body = { ...state.present.subRule.sorting, fields: tableFiltersToPass }
  const filterKeys = Object.keys(body.fields)
  filterKeys.forEach(element => {
    if (state.present.subRule.negateColumns.indexOf(element) !== -1) {
      body.fields[element] = NegateFilterSearched + body.fields[element]
    }
  })
  const isSuperCategoryEnabled = state.present.configuration.isSuperCategoryEnabled
  const typeOfChannel = state.present.discount.typeOfChannel
  const pricelistTypeFilter = state.present.configuration.pricelistTypeFilter

  body.fields.marketplaceAvailability = []

  body.fields.priceList1 = ''
  body.fields.priceList2 = ''
  body.fields.availability = isFilterAvailabilitySet ? -9999 : 0
  body.take = body.pageSize
  body.skip = (body.current - 1) * body.pageSize
  body.baseFilterSearch = discountArticleIdList.join(',')
  body.doSearchCount = true
  body.stores = prepareStores(state)

  const url =
    '/api/mprules/searchArticles/?' +
    `config=${state.present.article.serverConfig}` +
    `&isSuperCategoryEnabled=${isSuperCategoryEnabled}` +
    `&typeOfChannel=${typeOfChannel}` +
    `&ruleId=${rule?.id}&subRuleId=${subRuleId}` +
    `&onlyModified=${filterDiscountVisibilityDropdownValue}` +
    `&pricelistTypeFilter=${pricelistTypeFilter}`

  const response = await createRequest(url, 'POST', body, token, true, true)

  const result: { results: any[]; rowCount: number } = await response.json()
  return result
}

const populateSubRuleTableWithArticles = (keepPagination: boolean) => (dispatch, getState) => {
  const state = getState()
  if (!state.present.article.serverConfig) {
    return
  }

  dispatch(setLoading(true))
  if (!keepPagination) {
    dispatch(saveSorting({ ...state.present.tableOptions.sorting, current: 1 }))
  }

  searchSubRulesArticles(state)
    .then(data => {
      const { results, rowCount } = data
      const objectToDispatch = { count: rowCount, results: { results } }
      dispatch(setSubRuleArticles(objectToDispatch))
      dispatch(setActiveSubRuleAutocomplete(''))
    })
    .catch(err => {
      handleErrorCatchLog(err, 'Failed retrieve sub rule data populateSubRuleTableWithArticles')
      dispatch(setLoading(false))
    })
}

const saveSeasonSubrule =
  (subRule, navigationWrapper?: NavigationWrapper, searchParams?: URLSearchParams) => (dispatch, getState) => {
    const state = getState()
    const listingsDiscountToSave = state.present.subRule.listingsDiscountToSave
    const rule: any = retrieveRuleFromSubrule(subRule.virtualId ?? subRule.id, state.present.seasonRule.seasonRuleList)
    const token = getTokenFromSessionStorage()

    if (!state.present.article.serverConfig || !rule?.id || !token) {
      return new Promise(resolve => {
        resolve({})
      })
    }

    const isFromVirtualRule = subRule.virtualId

    return createRequest(
      '/api/mprules/' + rule.id + '/subrule?config=' + state.present.article.serverConfig,
      'POST',
      subRule,
      token,
      true,
      true,
    )
      .then(response => response.json())
      .then(x => {
        subRule.id = x
        dispatch(updateSubRule(subRule))
        dispatch(setEditSelection([]))

        if (listingsDiscountToSave.length > 0) {
          dispatch(updateDiscount(subRule.id, true, listingsDiscountToSave, isFromVirtualRule))
        }

        navigationWrapper?.navigateToSubrule(subRule.id, searchParams ? searchParams.toString() : null)
      })
      .catch(err => {
        handleErrorCatchLog(err, 'failed on save subrule saveSeasonSubrule')
      })
  }

const generateLabels = ruleId => (dispatch, getState) => {
  const state = getState()

  const token = getTokenFromSessionStorage()
  if (!state.present.article.serverConfig || !ruleId || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }
  return createRequest(
    '/api/mprules/' + ruleId + '/generateLabels?config=' + state.present.article.serverConfig,
    'POST',
    null,
    token,
    true,
    true,
  )
    .then(response => response.json())
    .catch(err => {
      handleErrorCatchLog(err, 'failed on generate labels')
    })
}
export {
  getSeasonRules,
  saveSeasonRule,
  deleteAllSeasonRules,
  deleteRule,
  getSeasons,
  copyEntireSeason,
  saveSeasonRuleCopy,
  populateSubRuleTableWithArticles,
  saveSeasonSubrule,
  restoreSeasonRules,
  addNewSeasonToSeasonList,
  generateLabels,
}
